const Colors = {
    inactive: '#A7B1C2',
};

export default Colors;



// WEBPACK FOOTER //
// ./src/utils/Colors.ts